<template>
  <div>
    <a href="http://www.broadinstitute.org/" target="_blank">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Broad.png"
        alt="Broad Institute"
        title="Broad Institute" />
      <img v-else src="./img/Broad-darkMode.png" alt="Broad Institute" title="Broad Institute" />
    </a>
    <a href="http://ami.org/" rel="nofollow">
      <img src="./img/AMI.png" alt="AMI" title="AMI" />
    </a>
    <a href="https://www.bio-itech.nl/" rel="nofollow">
      <img src="./img/logo-bio-itech.svg" alt="Bio-ITech" title="Bio-ITech" />
    </a>
    <a href="https://www.biodigital.com/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/BioDigital.png"
        alt="BioDigital"
        title="BioDigital" />
      <img v-else src="./img/BioDigital-darkMode.png" alt="BioDigital" title="BioDigital" />
    </a>
    <a href="https://clarafi.com/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/clarafi.png"
        alt="clarafi"
        title="clarafi" />
      <img v-else src="./img/clarafi-darkMode.png" alt="clarafi" title="clarafi" />
    </a>
  </div>
  <h4>Affiliations</h4>
  <div>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpg" alt="ISCB" title="ISCB" />
    </a>
  </div>
  <h4>Long-term support</h4>
  <div>
    <a href="http://www.nih.gov/">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/NIH.svg"
        alt="NIH"
        title="NIH"
        class="nih" />
      <img v-else src="./img/NIH-darkMode.svg" alt="NIH" title="NIH" class="nih" />
    </a>
  </div>
  <h4 id="why">About VIZBI Sponsorship</h4>
  <p>
    VIZBI is an international conference series on Visualizing Biological Data that alternates
    between the European Molecular Biology Laboratory in Heidelberg, Germany, and the Broad
    Institute of MIT and Harvard in Cambridge MA, USA, with support from the NIH.
  </p>
  <p>
    VIZBI 2018 offered opportunities to promote organisations engaged with either data
    visualisation or the life sciences. Sponsors gained exposure in a community that includes
    some of the most knowledgeable researchers and professionals working in biological data
    visualisation. Over 130 scientists, software developers, medical professionals, illustrators
    and designers from around the world attended VIZBI 2018. The 21 invited speakers reviewed
    state-of-the-art approaches and challenges in visualizing data from all of biology. Sponsor
    brands were advertised alongside these talks, and when videos and posters from VIZBI 2018
    were published on the main VIZBI site, which is accessed by over 3,000 life scientists each
    month.
  </p>
  <p>
    Sponsor logos were included in the printed program for the meeting and displayed on the
    website.
  </p>
  <p>
    If you are interested in future sponsorship opportunities, please download the
    <a href="/2018/Form.pdf" target="_blank">VIZBI sponsorship options</a> or contact
    us at <Email to="vizbi-contact" />.
  </p>
</template>

<script setup>
import Email from "@/components/Email.vue";
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
img.nih {
  max-height: calc(3.3rem * 1.4);
}
</style>
